<ion-header>
  <ion-toolbar>
    <ion-title>Obecné</ion-title>

    <ion-buttons slot="start">
      <ion-menu-button appMenuNotificationDot></ion-menu-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-segment [(ngModel)]="selectedTab">
    <ion-segment-button *ngFor="let tab of (visibleTabs$ | async)" [value]="tab.toString()">
      {{ tab === ConfigTabType.Obecne ? 'Obecné' : (tab === ConfigTabType.OA ? 'OA' : (tab === ConfigTabType.PS ? 'PS' :
      tab)) }}
    </ion-segment-button>
  </ion-segment>

  <form [formGroup]="form">
    <div *ngIf="selectedTab === ConfigTabType.Obecne">
      <ion-list>
        <ion-item-divider>
          <ion-label>Seznam asistentů</ion-label>
        </ion-item-divider>
        <ion-item>
          <ion-label>Volitelné sloupce</ion-label>
          <div class="align-end">
            <app-column-select
              [formControlName]="configKeys.ASSISTANT_LIST_CUSTOM_COLUMNS"
              [value]="configuredCustomColumns.assistantList | async"
              [columns]="availableCustomColumns.assistantList"
              [allowEmpty]="false"
            ></app-column-select>
          </div>
        </ion-item>
      </ion-list>

      <ion-list>
        <ion-item-divider>
          <ion-label>Údaje organizace</ion-label>
        </ion-item-divider>

        <ion-item>
          <ion-label>{{ 'CONFIG.ORGANIZATION_NAME' | transloco }}</ion-label>
          <ion-input [formControlName]="configKeys.ORGANIZACE_NAZEV"></ion-input>
        </ion-item>

        <ion-item class="row">
          <ion-label>Logo</ion-label>
          <div class="align-end">
            <input type="file" #logoInput (change)="onLogoFileChange($event)" accept="image/*" hidden />
            <div *ngIf="logo.base64" class="logo-preview-wrapper">
              <img [src]="logo.base64" alt="Logo Preview" class="logo-preview" (click)="logoInput.click()" />
              <ion-icon name="close-circle" class="remove-logo-icon" (click)="removeLogo()"></ion-icon>
            </div>
            <ion-button *ngIf="!logo.base64" (click)="logoInput.click()" style="margin-top: 5px">
              Vybrat obrázek
            </ion-button>
            <div *ngIf="form.get('logoFileControl').errors?.logoError" style="margin-top: 5px">
              <p style="color: red">{{ form.get('logoFileControl').errors.logoError }}</p>
            </div>
          </div>
        </ion-item>

        <ion-item>
          <ion-label>{{ 'CONFIG.ORGANIZATION_ADDRESS' | transloco }}</ion-label>
          <ion-input [formControlName]="configKeys.ORGANIZACE_ADRESA_SIDLA"></ion-input>
        </ion-item>

        <ion-item>
          <ion-label>{{ 'CONFIG.ORGANIZATION_ID_NUMBER' | transloco }}</ion-label>
          <ion-input [formControlName]="configKeys.ORGANIZACE_ICO"></ion-input>
        </ion-item>

        <ion-item>
          <ion-label>{{ 'CONFIG.ORGANIZATION_PHONE' | transloco }}</ion-label>
          <ion-input [formControlName]="configKeys.ORGANIZACE_TELEFON"></ion-input>
        </ion-item>

        <ion-item>
          <ion-label>{{ 'CONFIG.ORGANIZATION_BANK_ACCOUNT_NUMBER' | transloco }}</ion-label>
          <ion-input [formControlName]="configKeys.ORGANIZACE_CISLO_UCTU"></ion-input>
        </ion-item>

        <ion-item>
          <ion-label>{{ 'CONFIG.ORGANIZATION_BANK_NAME' | transloco }}</ion-label>
          <ion-input [formControlName]="configKeys.ORGANIZACE_BANKA"></ion-input>
        </ion-item>
      </ion-list>
    </div>
    <div *ngIf="selectedTab === ConfigTabType.OA.toString()">
      <fieldset>
        <legend>
          <ion-label>Pracovní hodiny koordinátorů</ion-label>
        </legend>
        <ion-item>
          Pracovní hodiny koordinátorů (v pracovní dny)
          <ejs-timepicker
            slot="end"
            [formControlName]="configKeys.ORDINACNI_HODINY_START_NO_TZ"
            [value]="configs[configKeys.ORDINACNI_HODINY_START_NO_TZ]"
          ></ejs-timepicker>
          <span slot="end">-</span>
          <ejs-timepicker
            slot="end"
            [formControlName]="configKeys.ORDINACNI_HODINY_END_NO_TZ"
            [value]="configs[configKeys.ORDINACNI_HODINY_END_NO_TZ]"
          ></ejs-timepicker>
        </ion-item>
      </fieldset>
      <fieldset>
        <legend>
          <ion-label>Pozdě objednané asistence</ion-label>
        </legend>
        <ion-item>
          Počet hodin před začátkem týdne, ve kterém asistence probíhá
          <ion-input
            slot="end"
            type="number"
            [formControlName]="configKeys.ODKDY_JE_POZDE_OBJEDNANA_ASISTENCE_HODINY"
            [value]="configs[configKeys.ODKDY_JE_POZDE_OBJEDNANA_ASISTENCE_HODINY]"
          ></ion-input>
          <ejs-tooltip
            slot="end"
            id="tooltip"
            [content]="tooltipTexts[configKeys.ODKDY_JE_POZDE_OBJEDNANA_ASISTENCE_HODINY]"
          >
            <ion-icon name="help-circle"></ion-icon>
          </ejs-tooltip>
        </ion-item>
        <ion-item>
          Vztahuje se i na asistence založené koordinátory
          <ion-checkbox
            slot="end"
            [formControlName]="configKeys.POZDE_OBJEDNANA_JESTLI_SE_VZTAHUJE_NA_KOORDINATORY"
          ></ion-checkbox>
          <ejs-tooltip
            slot="end"
            id="tooltip2"
            [content]="tooltipTexts[configKeys.POZDE_OBJEDNANA_JESTLI_SE_VZTAHUJE_NA_KOORDINATORY]"
          >
            <ion-icon name="help-circle"></ion-icon>
          </ejs-tooltip>
        </ion-item>
      </fieldset>
      <fieldset>
        <legend>
          <ion-label>Pozdní zrušení (storno) asistence</ion-label>
        </legend>
        <ion-item>
          Asistence je pozdě zrušená, když se zruší kolik hodin před plánovaným začátkem
          <ion-input
            slot="end"
            type="number"
            [formControlName]="configKeys.ODKDY_JE_POZDE_ZRUSENA_JIZ_POTVRZENA_ASISTENCE_HODINY"
            [value]="configs[configKeys.ODKDY_JE_POZDE_ZRUSENA_JIZ_POTVRZENA_ASISTENCE_HODINY]"
          ></ion-input>
        </ion-item>
        <ion-item>
          Do limitu pozdního zrušení se započítávají pouze pracovní dny
          <ion-checkbox
            slot="end"
            [formControlName]="configKeys.STORNO_BEZ_LIMITU_O_VIKENDECH_A_SVATCICH"
          ></ion-checkbox>
        </ion-item>
      </fieldset>
      <fieldset>
        <legend>
          <ion-label>Upravování proběhlých událostí</ion-label>
        </legend>
        <ion-item>
          Asistence: Počet dní, po které mohou koordinátoři provádět změny v proběhlé asistenci
          <ion-input
            slot="end"
            type="number"
            [formControlName]="configKeys.DOKDY_JE_MOZNA_EDITACE_PROBEHLYCH_ASISTENCI_DNY"
            [value]="configs[configKeys.DOKDY_JE_MOZNA_EDITACE_PROBEHLYCH_ASISTENCI_DNY]"
          ></ion-input>
        </ion-item>
      </fieldset>
      <fieldset>
        <legend>
          <ion-label>Přejezdy</ion-label>
        </legend>
        <ion-item>
          Výchozí doba přejezdu
          <ion-input
            slot="end"
            type="number"
            [formControlName]="configKeys.VYCHOZI_DOBA_PREJEZDU_MINUTY"
            [value]="configs[configKeys.VYCHOZI_DOBA_PREJEZDU_MINUTY]"
          ></ion-input>
          <div slot="end">minut</div>
        </ion-item>
      </fieldset>
      <fieldset>
        <legend>
          <ion-label>{{ 'CONFIG.JOURNAL_ENTRY_HISTORY_TITLE' | transloco }}</ion-label>
        </legend>
        <ion-item>
          {{ 'CONFIG.JOURNAL_ENTRY_HISTORY_SHOW_HISTORY' | transloco }}
          <ion-checkbox slot="end" [formControlName]="configKeys.JOURNAL_ENTRY_HISTORY_ENABLED"></ion-checkbox>
        </ion-item>
      </fieldset>
    </div>
    <div *ngIf="selectedTab === ConfigTabType.PS.toString()">
      <!-- PS tab content -->
    </div>
  </form>
</ion-content>
